export const getToggleButtonStyles = ({ shape, palette }) => ({
  textTransform: 'none',
  fontFamily: 'Roboto, sans-serif',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  borderRadius: shape.radius.l,
  border: `1px solid ${palette.border.input}`,
  color: palette.text.primary,
  backgroundColor: 'transparent',
  padding: '8px 12px',
  gap: '4px',

  '&.MuiToggleButton-sizeSmall': {
    padding: '4px 8px',
    fontSize: 12,
    lineHeight: '18px',

    '& .MuiToggleButton-icon, & svg': {
      width: '16px',
      height: '16px',
      fontSize: '16px',
    },
  },

  '&.MuiToggleButton-sizeLarge': {
    padding: '12px 16px',
    fontSize: 16,
    lineHeight: '26px',

    '& .MuiToggleButton-icon, & svg': {
      width: '24px',
      height: '24px',
      fontSize: '24px',
    },
  },

  '&:hover': {
    backgroundColor: palette.background.secondary,
  },

  '&:focus, &:focus-visible, &.Mui-focusVisible': {
    outline: 'none',
    boxShadow: 'none',
  },

  '&.Mui-selected': {
    color: palette.primary.main,
    backgroundColor: palette.primary.extraSoft,
    borderColor: palette.primary.main,

    '&:hover': {
      backgroundColor: palette.primary.soft,
    },
  },

  '&.Mui-disabled': {
    color: palette.text.disabled,
    borderColor: palette.border.input,
    opacity: 0.4,
  },

  '& .MuiToggleButton-icon, & svg': {
    width: '20px',
    height: '20px',
    fontSize: '20px',
  },
});

export const getToggleButtonGroupStyles = ({ palette }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    border: `1px solid ${palette.border.input}`,

    '&:not(:first-of-type)': {
      marginLeft: '-1px',
    },

    '&.Mui-selected': {
      borderColor: palette.primary.main,
      zIndex: 1,
    },
  },
});
